<template>
  <div class="callLog">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-alert
          title="只保留七天的消息推送记录"
          type="success"
          :closable="false"
          show-icon
        >
        </el-alert>
        <div class="flexBox" style="margin-top: 10px">
          <div>
            <span class="searchLabel">业务ID:</span>
            <el-input
              placeholder="请输入内容"
              v-model="idValue"
              class="input-with-select"
              style="margin: 0 10px 5px 0; width: 360px"
            >
              <el-select
                v-model="idType"
                slot="prepend"
                placeholder="请选择"
                style="width: 100px"
              >
                <el-option label="订单ID" value="order_no"></el-option>
                <el-option label="店铺ID" value="store_id"></el-option>
              </el-select>
            </el-input>
          </div>
          <div>
            <span class="searchLabel">消息类型:</span>
            <el-select
              v-model="msg_sub_type"
              clearable
              placeholder="选择消息类型"
              style="margin: 0 10px 5px 0; width: 360px"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <div style="display: inline-block; width: 150px"></div>
          </div>
        </div>
        <div class="flexBox">
          <div>
            <span class="searchLabel">推送状态:</span>
            <el-select
              v-model="status"
              clearable
              placeholder="选择推送状态"
              style="margin: 0 10px 5px 0; width: 360px"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
          <div>
            <span class="searchLabel">推送时间:</span>
            <el-date-picker
              v-model="time"
              type="daterange"
              style="margin: 0 10px 5px 0; width: 360px"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="selectTime"
            />
            <el-button @click="clear" id="clearBtn">重置</el-button>
            <el-button @click="getList" id="searchBtn" type="primary"
              >查询</el-button
            >
          </div>
        </div>
      </div>
      <div>
        <el-table
          :data="tableData"
          style="width: 100%"
          :header-cell-style="tableHeaderColor"
          :default-sort="{ prop: 'date', order: 'descending' }"
        >
          <el-table-column type="expand">
            <template slot-scope="props">
              <div class="columnInner">
                <div>推送地址：{{ props.row.notify_url }}</div>
                <div>请求：{{ props.row.content }}</div>
                <div>返回：{{ props.row.msg_return }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="id" label="ID" width="80" />
          <el-table-column prop="store_id" label="店铺ID" width="80" />
          <el-table-column prop="order_no" label="订单号" width="200" />
          <el-table-column prop="app_key" label="Appkey" width="140" />
          <el-table-column prop="create_time" label="推送时间" width="180" />
          <el-table-column label="消息类型" width="160">
            <template slot-scope="scope">
              {{
                typeObj.msg_sub_type &&
                typeObj.msg_sub_type[scope.row.msg_sub_type]
              }}
            </template>
          </el-table-column>
          <el-table-column label="消息类目">
            <template slot-scope="scope">
              {{ typeObj.msg_type && typeObj.msg_type[scope.row.msg_type] }}
            </template>
          </el-table-column>
          <el-table-column label="推送状态" width="120">
            <template slot-scope="scope">
              <div v-if="scope.row.status == 1">已推送</div>
              <div v-if="scope.row.status == 0">未推送</div>
              <div v-if="scope.row.status == 2">推送失败</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" align="center">
            <template slot-scope="scope">
              <el-popconfirm
                title="确定重发此消息吗？"
                @confirm="pushMsg(scope.row.id)"
              >
                <a class="linkBtn" slot="reference">重发</a>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <div class="pager">
          <el-pagination
            background
            :page-size="pagesize"
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :total="totalcount"
          >
          </el-pagination>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import apis from '@/api/apis'
export default {
  name: 'callLog',

  data() {
    return {
      //id类型
      idType: 'order_no',
      //id值
      idValue: '',
      //消息类型
      msg_sub_type: '',
      status: '',
      statusOptions: [
        {
          label: '已推送',
          value: '1',
        },
        {
          label: '未推送',
          value: '0',
        },
        {
          label: '推送失败',
          value: '2',
        }
      ],
      date: '',
      pagesize: 10,
      pagenum: 1,
      totalcount: 0,
      time: [],
      startTime: '',
      endTime: '',
      tableData: [],
      options: [],
      typeObj: {},
    }
  },

  mounted() {
    this.getTypeList()
    this.getList()
  },

  methods: {
    pushMsg(id) {
      apis.messagePush.pushAgain({ id }).then((res) => {
        this.$message({
          message: res.msg,
          type: 'success',
        })
        this.getList()
      })
    },
    handleCurrentChange(val) {
      this.pagenum = val
      this.getList()
    },
    getList() {
      apis.messagePush
        .msgList({
          start_time: this.startTime,
          end_time: this.endTime,
          status: this.status,
          [this.idType]: this.idValue,
          msg_sub_type: this.msg_sub_type,
          page: this.pagenum,
          page_size: this.pagesize,
        })
        .then((res) => {
          this.tableData = res.data.list
          this.totalcount = res.data.count
        })
    },
    getTypeList() {
      apis.messagePush.getMsgType({}).then((res) => {
        this.typeObj = res.data
        for (var k in res.data.msg_sub_type) {
          this.options.push({
            label: res.data.msg_sub_type[k],
            value: k,
          })
        }
      })
    },
    clear() {
      this.startTime = ''
      this.endTime = ''
      this.status = ''
      this.time = []
      this.idType = 'order_no'
      this.idValue = ''
      this.msg_sub_type = ''
      this.getList()
    },
    //选择时间
    selectTime() {
      this.startTime = this.filterTime(this.time[0])
      this.endTime = this.filterTime(this.time[1])
    },
    //中国标准时间转换格式
    filterTime(time) {
      var date = new Date(time)
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? '0' + m : m
      var d = date.getDate()
      d = d < 10 ? '0' + d : d
      var h = date.getHours()
      h = h < 10 ? '0' + h : h
      var minute = date.getMinutes()
      minute = minute < 10 ? '0' + minute : minute
      var s = date.getSeconds()
      s = s < 10 ? '0' + s : s
      return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + s
    },
    tableHeaderColor({ rowIndex }) {
      if (rowIndex === 0) {
        return 'background-color: #FAFAFA;color: #000;font-weight: 500;'
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.box-card {
  padding: 10px;

  background: #ffffff;
  .clearfix:before,
  .clearfix:after {
    display: table;
    content: '';
  }
  .clearfix:after {
    clear: both;
  }
  .pager {
    margin-top: 10px;
    width: 100%;
    height: 64px;
    background: #ffffff;
    padding-right: 30px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
.flexBox {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .searchLabel {
    color: rgba(0, 0, 0, 0.45);
    width: 75px;
    display: inline-block;
  }
}
.linkBtn {
  color: #0b4ffc;
  cursor: pointer;
}
.columnInner {
  width: 800px;
  padding: 0 40px;
  word-break: break-all;
}
::v-deep .el-card__header{
  padding-top:0;
  .el-alert--success.is-light{
    color:#0B4FFC;
    background-color: #0B4FFC0D;
    .el-alert__title{
      color:rgba(0,0,0,.65)
    }
  }
}
</style>
